import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface PreferencesState {
  /** Saved so staff and parents don't retype their school's code on every visit. */
  rememberedInstitutionId: string;
  rememberInstitution: boolean;
  setRememberedInstitution: (institutionId: string, remember: boolean) => void;
}

/** Per-device conveniences only. Nothing secret is ever stored here. */
export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      rememberedInstitutionId: "",
      rememberInstitution: true,
      setRememberedInstitution: (institutionId, remember) =>
        set({
          rememberedInstitutionId: remember ? institutionId : "",
          rememberInstitution: remember,
        }),
    }),
    {
      name: "eduleo.preferences",
      version: 1,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
